export enum ENACH_TRIGGER_TYPE {
  FORECLOSURE = 'FORECLOSURE_ENACH_PRESENTATION',
  CUSTOM = 'CUSTOM_ENACH_PRESENTATION',
  OVERDUE = 'OVERDUE_ENACH_PRESENTATION'
}
export const withAmountCsvFile =
  'loan_account_number,amount\n' + '01000000,10000\n' + '02000000,20000\n';
export const withoutAmountCsvFile = 'loan_account_number\n' + '01000000\n' + '02000000\n';

export enum FILE_STATUS {
  COMPLETED = 'APPLIED',
  PENDING = 'APPLY_INPROGRESS',
  FAILED = 'VALIDATION_FAILURE'
}
